import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const LogoIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-logo-icon ${className}`, height: '43.166', viewBox: '0 0 23.66 43.166', width: '23.66', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M214.348,508.072V503.8l18.977-8.015V478.979l-23.66,9.994v33.172l4.683-1.978v-6.481c.084-.033,8.162-3.407,13.75-5.742v-5.617C222.539,504.651,214.518,508,214.348,508.072Zm0-15.449c.281-.121,13.339-5.635,14.294-6.039v5.556l-14.294,6.036Z', fill: '#00154f', transform: 'translate(-209.665 -478.979)' }) })));
LogoIcon.propTypes = {
    className: propStr(),
};
LogoIcon.defaultProps = {
    className: '',
};
export default LogoIcon;
